import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/images/conmiapp_logo.jpeg";
import "./navbar.css";

function Navbar() {
  return (
    <div className="mobile-navbar-container">
      <Link to="/">
        <img src={logo} className="mobile-navbar-logo" alt="Conmiapp Logo" />{" "}
      </Link>
    </div>
  );
}

export default Navbar;
